"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Collections_Header = require("./Collections_Header");

var _Collections_Header2 = _interopRequireDefault(_Collections_Header);

var _Collection = require("./Collection");

var _Collection2 = _interopRequireDefault(_Collection);

var _Collection_Icon_Wrapper = require("./Collection_Icon_Wrapper");

var _Collection_Icon_Wrapper2 = _interopRequireDefault(_Collection_Icon_Wrapper);

var _Collections_Footer = require("./Collections_Footer");

var _Collections_Footer2 = _interopRequireDefault(_Collections_Footer);

var _SvgIcon = require("./SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ls = require("localstorage-ttl");

var Collections = function (_React$Component) {
	_inherits(Collections, _React$Component);

	function Collections(props) {
		_classCallCheck(this, Collections);

		var _this = _possibleConstructorReturn(this, (Collections.__proto__ || Object.getPrototypeOf(Collections)).call(this, props));

		_this.getCollections = function (offset, filter) {
			if (_this.options.cache && !offset) {
				// get the total no. of collections from cache
				_this.setState({
					total_collections: ls.get(iconPressConfig.plugin_slug + "_total_collections_" + _this.options.type + "_" + (filter || _this.state.filter)) || 0
				});

				// check for LS cache
				var cached_collections = ls.get(iconPressConfig.plugin_slug + "_collections_" + _this.options.type + "_" + (filter || _this.state.filter));

				if (cached_collections && Object.keys(cached_collections).length !== 0) {
					// if we have cache, update collection state
					// with stored data from LS
					_this.setState({
						collections: cached_collections,
						isLoading_mainComponent: false
					});
					if (iconPressConfig.debug === "1") {
						console.log("Fetching from LS.");
					}
					return;
				}
			}

			if (offset) {
				// enable loading state into
				// load more collections button
				_this.setState({
					isLoading_getNewCollections: true
				});
			}

			// append to query
			var doFilter = "&premium=" + (filter || _this.state.filter);
			var doOffset = offset ? "&after=" + offset : "";

			var that = _this;

			_this.props.api(_this.options.collectionsEndpoint + "?count=" + _this.options.count_collections + doOffset + doFilter, "get").then(function (response) {
				// bail if component is not mounted
				if (!_this._mounted) return;

				if (response.success !== void 0 && !response.success) {
					that.props.handleModal("error", "" + response.data);
				}

				if (response.iconsets === void 0) {
					if (iconPressConfig.debug === "1") {
						console.log("Iconsets not found.");
					}
					_this.setState({ isLoading_mainComponent: false });
					return;
				}

				// Set the Total Collections No.
				ls.set(iconPressConfig.plugin_slug + "_total_collections_" + _this.options.type + "_" + _this.state.filter, response.total_count, _this.cacheTime);

				_this.setState({
					total_collections: response.total_count
				});

				// loop through iconsets
				Object.keys(response.iconsets).map(function (key) {
					// get the icons
					_this.getIcons(response.iconsets[key]);
				});
			}).catch(function (error) {
				that.logErrors(error);
			});
		};

		_this.getIcons = function (collection, after) {
			if (!collection) {
				if (iconPressConfig.debug === "1") {
					console.log("Collection missing.");
				}
				return;
			}

			var lastItem = after ? "&after=" + after : "";

			// assign extra properties
			if (after) {
				var cLoading = {};
				cLoading[collection.iconset_id] = true;
				_this.setState({
					isLoading_getNewIconsFromCollection: cLoading
				});
			}

			var that = _this;

			// Get icons from iconset
			_this.props.api(_this.options.iconsEndpoint + "/?collection_identifier=" + collection.identifier + "&count=" + _this.options.count_icons + lastItem, "get").then(function (resp) {
				// bail if component is not mounted
				if (!_this._mounted) return;

				// Add some extra details to the icons
				resp.icons.map(function (item) {
					item.iconset_id = parseFloat(collection.iconset_id);
					item.icon_id = parseFloat(item.icon_id);
					// author
					item["author"] = {};
					item.author["name"] = collection.author_name ? collection.author_name : "";
					item.author["url"] = collection.author_url ? collection.author_url : "";
					// license
					item["license"] = {};
					item.license["name"] = collection.license_name ? collection.license_name : "";
					item.license["url"] = collection.license_url ? collection.license_url : "";

					// set the last icon as last
					if (item.is_last) {
						_this.setState({
							isLoading_getNewIconsFromCollection: {}
						});
					}
				});

				// when adding more icons to a collection
				if (collection.icons !== void 0 && collection.icons.length !== 0) {
					collection.icons = collection.icons.concat(resp.icons);
				}
				// on initial load, just add the icons
				else {
						collection.icons = resp.icons;
					}

				// set the last collection as last
				// called on initial load
				if (collection.is_last) {
					// update loading states
					_this.setState({
						isLoading_mainComponent: false,
						isLoading_getNewCollections: false
					});
				}

				// Help footer sticky bar by triggering a custom scroll event
				// on load more collections
				setTimeout(function () {
					window.dispatchEvent(new Event("scroll"));
				}, 300);

				var final = void 0;

				// check if this is an "append icons to collection" action
				// by verifying if "after" is provided
				// so just add the new icons into the state
				if (after) {
					var theCollections = [].concat(_toConsumableArray(_this.state.collections)).map(function (item, i) {
						if (item.iconset_id == collection.iconset_id) {
							return collection;
						}
						return item;
					});
					final = [].concat(_toConsumableArray(theCollections));
				} else {
					final = [].concat(_toConsumableArray(_this.state.collections), [collection]);
				}

				// update collections state
				_this.setState({
					collections: final
				});

				// Set Cache
				ls.set(iconPressConfig.plugin_slug + "_collections_" + _this.options.type + "_" + _this.state.filter, final, _this.cacheTime);
			});
		};

		_this.performSearch = function (q, offset, filter) {
			if (!q) {
				if (iconPressConfig.debug === "1") {
					console.log("Search query missing.");
				}
				return;
			}

			_this.setState({
				isLoading_search: true
			});

			// reset results on a new search
			if (!offset) {
				_this.setState({
					search: {}
				});
			}

			var searchResults = {};

			if (_this.options.cache) {
				// check for LS cache
				var cachedResults = ls.get(iconPressConfig.plugin_slug + "_search_" + _this.options.type + "_" + (filter || _this.state.filter));
				if (cachedResults && !offset) {
					var cachedSearchTerm = cachedResults.searchTerm;

					if (cachedSearchTerm && q === cachedSearchTerm) {
						_this.setState({
							isLoading_mainComponent: false,
							isLoading_search: false,
							search: cachedResults
						});
						console.log("Fetching results from LS.");
						return;
					}
				}
			}

			var doOffset = offset ? "&offset=" + offset : "";

			var that = _this;

			_this.props.api(_this.options.iconsEndpoint + "/search/?q=" + q + "&count=" + _this.options.count_icons + doOffset + "&premium=" + (filter || _this.state.filter), "get").then(function (response) {
				// bail if component is not mounted
				if (!_this._mounted) return;

				// load more on search
				if (Object.keys(_this.state.search).length !== 0 && _this.state.search.icons.length !== 0) {
					var results = _extends({}, _this.state.search);
					searchResults.total_count = results.total_count;
					searchResults.icons = results.icons.concat(response.icons);
				}
				// initial results
				else {
						searchResults = response;
					}

				_this.setState({
					isLoading_mainComponent: false,
					isLoading_search: false,
					search: searchResults
				});

				// Set Cache
				searchResults.searchTerm = q;
				ls.set(iconPressConfig.plugin_slug + "_search_" + _this.options.type + "_" + (filter || _this.state.filter), searchResults, _this.cacheTime);
			});

			return true;
		};

		_this.setFilter = function (filter) {
			_this.resetCollections();

			_this.setState({
				filter: filter,
				isLoading_mainComponent: true
			}, ls.set(iconPressConfig.plugin_slug + "_filter_" + _this.options.type, filter, _this.cacheTime));

			_this.getCollections(null, filter);
		};

		_this.filterSearch = function (filter) {
			_this.setState({
				filter: filter
			}, ls.set(iconPressConfig.plugin_slug + "_filter_" + _this.options.type, filter, _this.cacheTime));

			_this.performSearch(_this.props.searchTerm, null, filter);
		};

		_this.resetCollections = function () {
			_this.setState({
				collections: [],
				isLoading_getNewCollections: false
			});
		};

		_this.resetSearchResults = function () {
			_this.props.refreshSearchCache();
			_this.setState({
				search: {}
			});
		};

		_this.importDefaultCollections = function () {
			_this.setState({
				isLoading_import: true
			});

			_this.props.api(iconPressConfig.rest_url + "import_icons").then(function (response) {
				if (response.success) {
					// this.resetCollections();
					_this.getCollections();
					_this.setState({
						isLoading_import: false
					});
				}
			}).catch(function (error) {
				that.logErrors(error);
			});
		};

		_this.logErrors = function (error) {
			if (error.response !== void 0) {
				_this.props.handleModal("error", iconPressConfig.translations.ERROR_CODE + ": " + error.response.status + " " + error.response.data.code + ";\n " + error.response.data.message);
			}

			// show errors in console on Debug mode
			if (iconPressConfig.debug === "1") {
				console.log(error);
			}
		};

		_this._mounted;

		// Options
		_this.options = _this.props.options;

		// Cache time
		_this.cacheTime = 3600 * 1000; //1hr
		// this.cacheTime = 60 * 1000; // 1min (debug)

		_this.state = {
			collections: [],
			total_collections: 0,
			filter: ls.get(iconPressConfig.plugin_slug + "_filter_" + _this.options.type) || 0,
			search: {},
			isLoading_mainComponent: true,
			isLoading_getNewCollections: false,
			isLoading_getNewIconsFromCollection: {},
			isLoading_search: false,
			isLoading_import: false
		};
		return _this;
	}

	_createClass(Collections, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			this._mounted = true;

			// Check if there's a search term existing
			// and switch to search
			if (this.props.searchTerm !== "") {
				this.performSearch(this.props.searchTerm);
			}
			// if not, just show the icons
			else {
					this.resetCollections();
				}

			this.getCollections();
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			this._mounted = false;
			// cancel api requests.
		}
	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			// Show importer
			if (this.props.options.type == "local" && Object.keys(this.state.collections).length === 0 && this.state.total_collections === 0) {
				return _react2.default.createElement(
					"div",
					{ className: "ip-tabPane" },
					_react2.default.createElement(
						"div",
						{ className: "ip-tabPane-inner" },
						_react2.default.createElement(
							"p",
							null,
							iconPressConfig.translations.IMPORT_TITLE
						),
						_react2.default.createElement(
							"button",
							{
								className: "ip-loadMoreCollections --importer",
								onClick: function onClick(event) {
									return _this2.importDefaultCollections();
								}
							},
							this.state.isLoading_import ? _react2.default.createElement(_SvgIcon2.default, { icon: "spinner" }) : iconPressConfig.translations.IMPORT_DEFAULT
						)
					)
				);
			}

			var btnMore = iconPressConfig.translations.NO_MORE_COLLECTIONS;

			if (Object.keys(this.state.collections).length !== 0 && Object.keys(this.state.collections).length < this.state.total_collections) {
				var btnText = iconPressConfig.translations.LOAD_MORE_COLLECTIONS;
				var btnClass = "";
				if (this.state.isLoading_getNewCollections) {
					btnText = _react2.default.createElement(_SvgIcon2.default, { icon: "spinner" });
					btnClass = "is-loading";
				}

				// get the last declared item
				var lastItemID = [].concat(_toConsumableArray(this.state.collections)).filter(function (el) {
					return el.is_last == true;
				});

				// check if empty (probably because of interrupted request)
				// and set the last item as is_last
				if (!lastItemID.length) {
					lastItemID = [].concat(_toConsumableArray(this.state.collections)).slice(-1);
				}
				// only iconset_id is needed
				lastItemID = lastItemID.slice(-1)[0].iconset_id;
				btnMore = _react2.default.createElement(
					"button",
					{
						className: "ip-loadMoreCollections " + btnClass,
						onClick: function onClick(event) {
							return _this2.getCollections(lastItemID);
						}
					},
					btnText
				);
			}

			// Default Collections
			var pageView = _react2.default.createElement(
				"div",
				{ className: "ip-collections" },
				Object.keys(this.state.collections).map(function (key) {
					return _react2.default.createElement(_Collection2.default, {
						key: _this2.state.collections[key].iconset_id,
						collection: _this2.state.collections[key],
						selected: _this2.props.selected,
						toggleSelected: _this2.props.toggleSelected,
						loadMore: _this2.getIcons,
						isLoadingNewIcons: _this2.state.isLoading_getNewIconsFromCollection
					});
				}),
				btnMore
			);

			// If searching
			if (this.props.searchTerm) {
				// if there are results, show them.
				if (Object.keys(this.state.search).length !== 0) {
					// Check if button is loading
					var _btnText = iconPressConfig.translations.LOAD_MORE;
					var _btnClass = "";
					if (this.state.isLoading_search) {
						_btnText = _react2.default.createElement(_SvgIcon2.default, { icon: "spinner" });
					}

					var iconsResults = this.state.search.icons;

					pageView = _react2.default.createElement(
						"div",
						{ className: "ip-search-results" },
						_react2.default.createElement(_Collection_Icon_Wrapper2.default, {
							items: iconsResults,
							selected: this.props.selected,
							toggleSelected: this.props.toggleSelected
						}),
						iconsResults.length < parseFloat(this.state.search.total_count) && _react2.default.createElement(
							"button",
							{
								className: "ip-loadMoreIcons",
								onClick: function onClick(event) {
									_this2.performSearch(_this2.props.searchTerm, iconsResults.length);
								}
							},
							_btnText
						)
					);
				} else if (this.state.isLoading_search) {
					pageView = _react2.default.createElement(
						"div",
						{ className: "ip-search-loading" },
						_react2.default.createElement(_SvgIcon2.default, { icon: "spinner" })
					);
				}
				// if not show no results message
				else {
						pageView = _react2.default.createElement(
							"div",
							{ className: "ip-search-noResults" },
							iconPressConfig.translations.NO_RESULTS
						);
					}
			}

			return _react2.default.createElement(
				"div",
				{ className: "ip-tabPane" },
				_react2.default.createElement(
					"div",
					{ className: "ip-tabPane-inner" },
					_react2.default.createElement(_Collections_Header2.default, {
						size: this.props.size,
						updateSize: this.props.updateSize,
						updateSearchTerm: this.props.updateSearchTerm,
						performSearch: this.performSearch,
						filterSearch: this.filterSearch,
						searchTerm: this.props.searchTerm,
						resetSearchResults: this.resetSearchResults,
						setFilter: this.setFilter,
						filter: this.state.filter,
						showFilter: this.options.showFilter,
						searchIsLoading: this.state.isLoading_search,
						componentIsLoading: this.state.isLoading_mainComponent,
						newCollectionIsLoading: this.state.isLoading_getNewCollections
					}),
					this.state.isLoading_mainComponent ? _react2.default.createElement(
						"div",
						{ className: "ic-preloader" },
						_react2.default.createElement(_SvgIcon2.default, { icon: "spinner" })
					) : pageView,
					_react2.default.createElement(_SvgIcon2.default, { icon: "spinner", className: "ip-savingSpinner" })
				),
				_react2.default.createElement(_Collections_Footer2.default, {
					selected: this.props.selected,
					handleSave: this.props.handleSave,
					mainIsLoading: this.state.isLoading_mainComponent,
					context: this.props.context
				})
			);
		}
	}]);

	return Collections;
}(_react2.default.Component);

exports.default = Collections;


//////////////////
// WEBPACK FOOTER
// ./src/components/Collections.js
// module id = 254
// module chunks = 0 1